module.exports = __webpack_public_path__ + "images/psp/FeaturedContentImages/driveUpFeatured2.png";